import React from "react";
import { SmartTableNewInterface } from "soft_digi";
import { METER_READINGS_URLS } from "../../api/UserUrls";
import ImportExcelLayout from "../../components/site/ImportExcelLayout";

interface HeaderProps {
  loadTableData: () => void;
}

const ImportReportTable: React.FC<HeaderProps> = ({ loadTableData }) => {
  const columns: SmartTableNewInterface.SmartTableNewColumnConfig[] = [
    { title: "S.NO", index: "s_no", type: "sno", width: "5" },
    { title: "Hub", index: "hub_name", width: "15" },
    { title: "Meter Start", index: "meter_start", width: "15" },
    { title: "Meter End", index: "meter_end", width: "15" },
    { title: "Start Date", index: "start_date", width: "10", type: "date" },
    { title: "End Date", index: "end_date", width: "10", type: "date" },
    { title: "Units", index: "count", width: "15" },
    {
      title: "Status",
      index: "status",
      width: "15",
      type: "tags",
      tags: [
        { value: 5, label: "Success", class: "is-success" },
        { value: 10, label: "Error", class: "is-danger" },
      ],
    },
    { title: "Remarks", index: "msg", width: "15" },
  ];

  return (
    <ImportExcelLayout
      loadTableData={loadTableData}
      uploadUrl={METER_READINGS_URLS.IMPORT_EXCEL}
      templateHeaders={["S.NO", "Hub", "Meter Start", "Meter End", "Start Date", "End Date", "Units"]}
      templateSampleData={[
        ["1", "Hub01", "1000", "1500", "01-01-2024", "31-01-2024", "500"],
        ["2", "Hub02", "2000", "2800", "01-01-2024", "31-01-2024", "800"],
      ]}
      templateFileName="meter_reading_template.xlsx"
      description="Download the template, fill in your meter reading data, and upload it below."
      columns={columns}
    />
  );
};

export default ImportReportTable;
